
	import { defineComponent, ref, onBeforeMount, toRefs } from 'vue';

	// Components
	import templateContentAsset from './template-content-asset.vue';
	import templateContentContent from './template-content-content.vue';
	import templateContentBespoke from './template-content-bespoke.vue';
	import templateContentImage from './template-content-image.vue';
	import templateContentSvg from './template-content-svg.vue';
	import templateContentVideo from './template-content-video.vue';

	export default defineComponent ({
		name: 'template-area',
		components: {
			templateContentAsset,
			templateContentContent,
			templateContentBespoke,
			templateContentImage,
			templateContentSvg,
			templateContentVideo,
		},
		props: {
			datum: {
				type: Object,
				required: true
			},
			carouselIndex: {
				type: Number,
				default: 0
			}
		},
		setup(props) {
			const areaStyle = ref('');
			const { datum } = toRefs(props);

			onBeforeMount(() => {
				if (datum.value.width) {
					areaStyle.value = `width: ${datum.value.width}`;
				}
			})

			return { areaStyle }
		}
	})
